@if (text) {
  <div [class]="containerClass">
    <div [class]="lineClass"></div>
    <span [class]="textClass">{{ text }}</span>
    <div [class]="lineClass"></div>
  </div>
} @else {
  <div [class]="lineClass"></div>
}
